import { navigateTo } from '#imports'

import {
  type OrderlineOpenTask,
  type OrderlineRequest,
  getNextTask,
} from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-customer-care'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'

import { ROUTE_NAMES } from '~/constants/routes'

export async function fetchAndGoToNextTask(taskId?: string) {
  const { resolutionId } = await $httpFetch(getNextTask, {
    pathParams: { taskId },
  })

  if (resolutionId) {
    await navigateTo({
      name: ROUTE_NAMES.CUSTOMER_CARE.REQUEST_RESOLUTION,
      params: {
        resolutionId,
      },
    })
  } else {
    await navigateTo({
      name: ROUTE_NAMES.CUSTOMER_CARE.OPEN_TASKS,
      query: { taskCompleted: 'true' },
    })
  }
}

export function getAllTasks(
  orderlineRequests: OrderlineRequest[],
): OrderlineOpenTask[] {
  return orderlineRequests.reduce(
    (allTasks: OrderlineOpenTask[], request) => [
      ...allTasks,
      ...request.openTasks,
    ],
    [],
  )
}

export function getMostUrgentTask(
  requests: OrderlineRequest[],
  resolutionId: string | null,
): OrderlineOpenTask | undefined {
  const requestsForCurrentResolutionId = requests.filter(
    (request) => request.resolutionId === resolutionId,
  )

  // Gets task with of requests with the current resolutionId in priority to avoid looping over the same tasks
  const allTasks = getAllTasks(
    requestsForCurrentResolutionId.length
      ? requestsForCurrentResolutionId
      : requests,
  )

  const openTasks = allTasks.filter((task) => task.status === 'OPEN')
  const orderedTask = openTasks.sort(
    (a, b) => Date.parse(a.deadline) - Date.parse(b.deadline),
  )

  return orderedTask[0]
}
